<template>
  <div class="c-question-info">
    <div class="question-tit q-f-bold">{{questionInfo.Question.Title || ''}}</div>
    <div class="q-description" v-html="questionInfo.ProgramItem.Description"></div>
    <div class="q-time-limit" v-if="!ispy || questionInfo.ProgramItem.TimeLimit">时间限制：{{questionInfo.ProgramItem.TimeLimit || ''}}</div>
    <div class="q-memory-limit" v-if="!ispy || questionInfo.ProgramItem.MemoryLimit">内存限制：{{questionInfo.ProgramItem.MemoryLimit || ''}}</div>
    <template v-if="questionInfo.ProgramItem.Input && (!ispy || questionInfo.ProgramItem.Input.Description)">
      <div class="q-input-tit q-f-bold">输入</div>
      <div class="q-input-description" v-html="questionInfo.ProgramItem.Input.Description"></div>
    </template>
    <template v-if="questionInfo.ProgramItem.Output && (!ispy || questionInfo.ProgramItem.Output.Description)">
      <div class="q-output-tit q-f-bold">输出</div>
      <div class="q-output-description" v-html="questionInfo.ProgramItem.Output.Description"></div>
    </template>
    <template v-if="questionInfo.ProgramItem.Input && (!ispy || questionInfo.ProgramItem.Input.Example)">
      <div class="q-sample-input-tit q-f-bold">样例输入</div>
      <pre class="q-sample">{{questionInfo.ProgramItem.Input.Example || ''}}</pre>
    </template>
    <template v-if="questionInfo.ProgramItem.Output && (!ispy || questionInfo.ProgramItem.Output.Example)">
      <div class="q-sample-output-tit q-f-bold">样例输出</div>
      <pre class="q-sample">{{questionInfo.ProgramItem.Output.Example || ''}}</pre>
    </template>
    <template v-if="questionInfo.ProgramItem.Hint">
      <div class="q-output-tit q-f-bold" style="margin-top: 20px;">提示</div>
      <div class="q-output-description" v-html="questionInfo.ProgramItem.Hint || ''"></div>
    </template>
  </div>
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex';
  import Languages from '../../scripts/common/language';

  export default {
    name: 'c-question-info',
    data() {
      return {
      }
    },
    computed: {
      ...mapGetters(['questionInfo', 'language']),
      ispy() {
        return this.language.key == Languages.py.key;
      },
    },
    mounted() {
      console.log('questionInfo', this.questionInfo);
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>

  @import "../../assets/scss/base/variables.scss";

  .c-question-info {
    padding: $i-m;
    background-color: #fff;
    flex-grow: 1;
    color: $c-f;
    overflow-y: scroll;

    .question-tit {
      font-size: $f-xl;
    }

    .q-description {
      font-size: $f-s;
      margin-top: 16px;
    }

    .q-time-limit {
      font-size: $f-s;
      margin-top: 12px;
    }

    .q-memory-limit {
      font-size: $f-s;
    }

    .q-input-tit {
      margin-top: 24px;
    }

    .q-input-description {
    }

    .q-output-tit {
      margin-top: $i-s;
    }

    .q-output-description {
    }

    .q-sample-input-tit {
      margin-top: 24px;
    }

    .q-sample {
      color: #666666;
      border: 1px solid #e9e9e9;
      border-radius: $r-m;
      background-color: #f6f4f4;
      padding: $i-s;
      margin-top: 5px;
      white-space: pre-wrap;
    }

    .q-sample-output-tit {
      margin-top: 19px;
    }

    .q-f-bold {
      font-weight: bold;
    }
  }
</style>
